<template>
  <div class="min-h-screen px-6 py-8 md:px-10">
    <div class="w-full space-y-6">
      <div>
        <h1 class="mt-2 text-3xl text-gray-900">
          Relatório de envio clientes
        </h1>
        <p class="mt-2 max-w-2xl text-sm text-gray-500">
          Consulte os envios, conversas, operadores e tarifas por cliente.
        </p>
      </div>

      <div class="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="p-6">
          <form @submit.prevent="start">
            <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
              <div class="flex flex-col gap-1">
                <label for="de" class="text-sm font-medium text-gray-500">
                  A partir de
                </label>
                <input
                  v-model="form.de"
                  type="datetime-local"
                  id="de"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex flex-col gap-1">
                <label for="ate" class="text-sm font-medium text-gray-500">
                  Até
                </label>
                <input
                  v-model="form.ate"
                  type="datetime-local"
                  id="ate"
                  class="h-11 rounded-xl border border-gray-200 px-4 shadow-sm outline-none transition-all duration-200 focus:border-blue-100 focus:ring-2 focus:ring-blue-100"
                />
              </div>

              <div class="flex items-end gap-2">
                <button
                  type="submit"
                  class="h-11 w-full rounded-xl font-medium text-white transition"
                  :style="{ backgroundColor: primaryColor }"
                  @mouseenter="$event.target.style.backgroundColor = mixPrimaryColor('#111827', 0.2)"
                  @mouseleave="$event.target.style.backgroundColor = primaryColor"
                >
                  Gerar relatório
                </button>

                <button
                  v-if="silvestre"
                  type="button"
                  class="h-11 w-full rounded-xl border border-gray-300 bg-white font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50"
                  :disabled="data.length === 0"
                  @click="downloadCsv"
                >
                  Baixar CSV
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div
        v-if="novaVida"
        class="overflow-hidden rounded-2xl border border-gray-200 bg-white p-6 shadow-sm"
      >
        <span class="text-sm font-medium text-gray-500">Total</span>
        <p class="mt-2 text-3xl text-green-700">
          {{ formatPrice(total_tarifa) }}
        </p>
      </div>

      <div class="w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
        <div class="overflow-x-auto">
          <table class="w-full min-w-max text-sm">
            <thead class="border-b bg-gray-100 tracking-wider text-gray-600">
              <tr>
                <th class="px-6 py-4 text-left font-medium">Cliente</th>
                <th class="px-6 py-4 text-left font-medium">Produto</th>
                <th v-if="novaVida" class="px-6 py-4 text-left font-medium">Rota</th>
                <th v-if="novaVida" class="px-6 py-4 text-left font-medium">Cobrança</th>
                <th v-if="novaVida" class="px-6 py-4 text-left font-medium">Saldo Pré Pago</th>
                <th v-if="novaVida" class="px-6 py-4 text-left font-medium">Limite Mensal Pós Pago</th>
                <th class="px-6 py-4 text-left font-medium">
                  {{ novaVida ? $store.getters.rotuloEnvio('Envio Massa / Enviados', 'Envio Massa / Enviados para fila') : 'Envio Massa' }}
                </th>
                <th class="px-6 py-4 text-left font-medium">
                  {{ novaVida ? "Conversas / Respostas" : "Conversas Geradas" }}
                </th>
                <th class="px-6 py-4 text-left font-medium">Operadores Tarifados</th>
                <th class="px-6 py-4 text-left font-medium">Operadores Totais</th>
                <th v-if="!novaVida" class="px-6 py-4 text-left font-medium">Validação</th>
                <th v-if="novaVida" class="px-6 py-4 text-left font-medium">Canal Personalizado</th>
                <th v-if="novaVida" class="px-6 py-4 text-left font-medium">Tarifado</th>
                <th class="px-6 py-4 text-left font-medium">Total</th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="el in data"
                :key="el._id"
                class="border-b border-gray-100 transition hover:bg-slate-50"
              >
                <td class="px-6 py-5">
                  <div class="flex items-center gap-4">
                    <div class="flex h-11 w-11 items-center justify-center rounded-2xl bg-blue-50 text-sm font-semibold text-blue-700">
                      {{ (el.clienteNome || el.clienteEmail || '').slice(0, 2).toUpperCase() }}
                    </div>

                    <div class="flex flex-col">
                      <span class="font-medium text-gray-800">
                        {{ el.clienteNome || "-" }}
                      </span>
                      <span v-if="!novaVida" class="text-xs text-gray-400">
                        {{ el.clienteEmail || "-" }}
                      </span>
                    </div>
                  </div>
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ el.produto || "-" }}
                </td>

                <td v-if="novaVida" class="px-6 py-5 font-medium text-gray-700">
                  {{ el.rota || "-" }}
                </td>

                <td v-if="novaVida" class="px-6 py-5 font-medium text-gray-700">
                  {{ el.tipoCobranca || "-" }}
                </td>

                <td v-if="novaVida" class="px-6 py-5 font-medium text-gray-700">
                  {{ el.saldoPrePago || 0 }}
                </td>

                <td v-if="novaVida" class="px-6 py-5 font-medium text-gray-700">
                  {{ el.limiteMensal || 0 }}
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ formatLinhaValor(el.entregues_enviados, el.tarifaMassa, el.valorMassa) }}
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ formatLinhaValor(el.conversas_retornos, el.tarifaConversas, el.valorConversas) }}
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ formatLinhaValor(el.qtdOperador, el.tarifaOperadores, el.valorOperadores) }}
                </td>

                <td class="px-6 py-5 font-medium text-gray-700">
                  {{ el.totalOperadores || 0 }}
                </td>

                <td v-if="!novaVida" class="px-6 py-5 font-medium text-gray-700">
                  {{ el.validacao || 0 }}
                </td>

                <td v-if="novaVida" class="px-6 py-5 font-medium text-gray-700">
                  {{ el.canal_personalizado ? "Sim" : "Não" }}
                  {{ el.valorPersonalizado ? formatPrice(el.valorPersonalizado) : "" }}
                </td>

                <td v-if="novaVida" class="px-6 py-5">
                  <span
                    class="rounded-full px-3 py-1 text-xs font-medium"
                    :class="el.tarifado ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
                  >
                    {{ el.tarifado ? "Sim" : "Não" }}
                  </span>
                </td>

                <td class="px-6 py-5 font-semibold text-green-700">
                  {{ el.total || 0 }}
                </td>
              </tr>

              <tr v-if="data.length === 0">
                <td
                  :colspan="novaVida ? 13 : 8"
                  class="px-6 py-12 text-center text-sm text-gray-400"
                >
                  Nenhum registro encontrado com os filtros atuais.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { colorMixin } from '@/utils/colorMixin';

export default {
  mixins: [colorMixin],
  data() {
    return {
      novaVida: false,
      silvestre: false,
      route: "relatorio-envio",
      moment,
      data: [],
      form: {
        de: moment().startOf("month").format("YYYY-MM-DDTHH:mm"),
        ate: moment().endOf("month").format("YYYY-MM-DDTHH:mm")
      },
      total_tarifa: 0,
      totalEnvios: 0,
      totalEnviados: 0,
      totalNaoEnviados: 0
    };
  },

  methods: {
    formatPrice(value) {
      const number = Number(value || 0);

      return number.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },

    formatLinhaValor(quantidade, tarifa, valor) {
      const partes = [quantidade || 0];

      if (valor && tarifa) {
        partes.push(`x ${this.formatPrice(tarifa)}`);
        partes.push(`= ${this.formatPrice(valor)}`);
      }

      return partes.join(" ");
    },

    formatCsvValue(value) {
      if (value === null || value === undefined) {
        return '""';
      }

      return `"${String(value).replace(/"/g, '""').replace(/\r?\n/g, " ")}"`;
    },

    downloadCsv() {
      if (this.data.length === 0) {
        return;
      }

      const cabecalho = [
        "Cliente",
        "ID Custom",
        "Data do relatório",
        "Produto",
        "Rota",
        "Tipo de cobrança",
        "Saldo pré-pago",
        "Limite mensal pós-pago",
        this.$store.getters.rotuloEnvio("Envio em massa / enviados", "Envio em massa / enviados para fila"),
        "Conversas / respostas",
        "Operadores tarifados",
        "Operadores totais",
        "Validação",
        "Total"
      ];

      const linhas = this.data.map(el => [
        el.clienteNome || "",
        el.idCustom || "",
        el.dataRelatorio || "",
        el.produto || "",
        el.rota || "",
        el.tipoCobranca || "",
        el.saldoPrePago || 0,
        el.limiteMensal || 0,
        el.entregues_enviados || 0,
        el.conversas_retornos || 0,
        el.qtdOperador || 0,
        el.totalOperadores || 0,
        el.validacao || 0,
        el.total || 0
      ]);

      const csv = `\uFEFF${[cabecalho, ...linhas]
        .map(linha => linha.map(this.formatCsvValue).join(";"))
        .join("\r\n")}`;
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const inicio = moment(this.form.de).format("YYYY-MM");
      const fim = moment(this.form.ate).format("YYYY-MM");
      const periodo = inicio === fim ? inicio : `${inicio}_a_${fim}`;

      link.href = url;
      link.download = `Relatorio-Silvestre-${periodo}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    async start() {
      const userId = this.$store.state.user._id.toString();

      this.silvestre = userId === "677bef54e735894ed49a2fe4";

      const url =
        userId === "626a87fec9cf2abcd1265acf"
          ? "/relatorio-trestto"
          : userId === "677bef54e735894ed49a2fe4"
          ? "/relatorio-silvestre"
          : userId === "690ce44750612ed5cb237b15"
          ? "/relatorio-oneconnect"
          : "/relatorio-novavida";

      this.novaVida = userId === "626a87fec9cf2abcd1265acf" ? false : true;

      const de = moment(this.form.de).startOf("month").format("YYYY-MM-DDTHH:mm");
      const ate = moment(this.form.ate).endOf("month").format("YYYY-MM-DDTHH:mm");

      const listReq = await this.$http.get(`${url}?de=${de}&ate=${ate}`);

      this.data = listReq.data.data || [];
      this.total_tarifa = listReq.data.total_tarifa || 0;
    }
  },

  async beforeMount() {
    await this.start();
  }
};
</script>
